import React, { useState, useEffect } from "react";
import {
  IntervalConfiguration,
  GlobalConfiguration,
} from "./configurationProvider";

const CountdownTimer = ({
  time = IntervalConfiguration.statementRefreshTime,
  isDisabled = false,
  resetTrigger,
}) => {
  const [timeLeft, setTimeLeft] = useState(time);

  // Reset timer whenever resetTrigger or time changes
  useEffect(() => {
    setTimeLeft(time);
  }, [time, resetTrigger]);

  useEffect(() => {
    if (isDisabled || timeLeft <= GlobalConfiguration.lengthCheckZero) return;

    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return GlobalConfiguration.lengthCheckZero;
        }
        return prev - GlobalConfiguration.lengthCheckOne;
      });
    }, IntervalConfiguration.intervalMedium);

    return () => clearInterval(interval);
  }, [timeLeft, isDisabled]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / IntervalConfiguration.minuteInSecond);
    const secs = seconds % IntervalConfiguration.minuteInSecond;

    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return <>{formatTime(timeLeft)}</>;
};

export default CountdownTimer;
